export const tpoGenKeys = {
    all: ['tpo-gen'] as const,

    config: () => [...tpoGenKeys.all, 'config'] as const,

    planFilters: () => [...tpoGenKeys.all, 'plan-filters'] as const,
    planFiltersByDim: (dim: string, payload: Record<string, unknown>) =>
        [...tpoGenKeys.planFilters(), dim, payload] as const,

    dimOptions: () => [...tpoGenKeys.all, 'dim-options'] as const,

    planList: (
        planningGroupId: string,
        showMyPlans: boolean,
        filters?: Record<string, any>,
        sortBy?: string,
        sortOrder?: string,
        limit?: number,
    ) =>
        [
            ...tpoGenKeys.all,
            'plan-list',
            planningGroupId,
            showMyPlans,
            filters ?? {},
            sortBy ?? 'last_updated',
            sortOrder ?? 'desc',
            limit ?? 0,
        ] as const,

    planningGroups: (
        search?: string,
        myPlansOnly?: boolean,
        filters?: Record<string, any>,
        sortBy?: string,
        sortOrder?: string,
    ) =>
        [
            ...tpoGenKeys.all,
            'planning-groups',
            search ?? '',
            myPlansOnly ?? false,
            filters ?? {},
            sortBy ?? 'last_updated',
            sortOrder ?? 'desc',
        ] as const,

    editLock: (planId: string) => [...tpoGenKeys.all, 'edit-lock', planId] as const,

    eventDetails: (eventId: string) => [...tpoGenKeys.all, 'event-details', eventId] as const,

    promoDetails: (promoId: string) => [...tpoGenKeys.all, 'promo-details', promoId] as const,

    importablePlans: (planId: string, search: string, isTPMPlan: boolean) =>
        [...tpoGenKeys.all, 'importable-plans', planId, search, isTPMPlan] as const,
    importableEvents: (sourcePlanId: string | null, targetPlanId: string | null, search: string) =>
        [...tpoGenKeys.all, 'importable-events', sourcePlanId ?? '', targetPlanId ?? '', search] as const,

    comparisonReports: () => [...tpoGenKeys.all, 'comparison-reports'] as const,
    comparisonReportList: (
        searchKey?: string,
        myReports?: boolean,
        filters?: Record<string, unknown>,
        sortBy?: string,
        sortOrder?: string,
    ) =>
        [
            ...tpoGenKeys.comparisonReports(),
            searchKey ?? '',
            myReports ?? false,
            filters ?? {},
            sortBy ?? 'updated_at',
            sortOrder ?? 'desc',
        ] as const,

    comparisonReportDetail: (reportId: string) =>
        [...tpoGenKeys.all, 'comparison-report-detail', reportId] as const,

    universePlans: (dim1Labels: string[], dim2Labels: string[], search?: string, exclude?: string[]) =>
        [...tpoGenKeys.all, 'universe-plans', ...dim1Labels.sort(), ...dim2Labels.sort(), search ?? '', ...(exclude ?? []).sort()] as const,

    plansComparisonTable: (basePlanId: string, comparisonPlanIds: string[], kpiList: string[], metricType: string, searchKey?: string) =>
        [...tpoGenKeys.all, 'plans-comparison-table', basePlanId, ...comparisonPlanIds.sort(), ...kpiList.sort(), metricType, searchKey ?? ''] as const,

    kpiBreakdown: (
        planIds: string[],
        basePlanId: string,
        kpiKey: string,
        groupBy: string,
        metricType?: string,
        timePeriod?: string,
        search?: string,
    ) =>
        [
            ...tpoGenKeys.all,
            'kpi-breakdown',
            ...[...planIds].sort(),
            basePlanId,
            kpiKey,
            groupBy,
            metricType ?? 'abs',
            timePeriod ?? 'full_year',
            search ?? '',
        ] as const,

    comparisonReportFilterOptions: (attributeType: string, filters?: Record<string, unknown>) =>
        [...tpoGenKeys.all, 'comparison-report-filters', attributeType, filters ?? {}] as const,

    promotionCount: (planId: string, scopeFilters: Record<string, any>, startDate: number | null) =>
        [...tpoGenKeys.all, 'promotion-count', planId, scopeFilters, startDate] as const,

    constraintOriginalValues: (request: Record<string, any>) =>
        [...tpoGenKeys.all, 'constraint-original-values', request] as const,

    objectiveOptions: () => [...tpoGenKeys.all, 'objective-options'] as const,

    optimizationStatus: (jobId: string) => [...tpoGenKeys.all, 'optimization-status', jobId] as const,

    optimizationId: (planId: string) => [...tpoGenKeys.all, 'optimization-id', planId] as const,
    
    optimizeOptions: () => [...tpoGenKeys.all, 'optimize-options'] as const,
    
    optimisedResults: (jobId: string, planId: string) =>
        [...tpoGenKeys.all, 'optimised-results', jobId, planId] as const,
    infeasibilityExplanation: (jobId: string) => [...tpoGenKeys.all, 'infeasibility-explanation', jobId] as const,
    promoLibrary: () => [...tpoGenKeys.all, 'promo-library'] as const,

    reportExportStatus: (exportId: string) => [...tpoGenKeys.all, 'report-export-status', exportId] as const,
};

const TPO_GEN_DIM_OPTIONS_QUERY_KEY = 'tpo-gen-dim-options';

export { TPO_GEN_DIM_OPTIONS_QUERY_KEY };
